{
  "key": "kerbside-primary-school-oval",
  "title": "Kerbside Primary School oval",
  "suburb": "Kerbside",
  "locationGroup": "ovals",
  "grassType": "buffalo",
  "cellM": 1,
  "gameScale": 2.5,
  "w": 84,
  "h": 60,
  "rows": [
    "....................................................................................",
    "....................................................................................",
    "....................................................................................",
    "....................................................................................",
    "....................................................................................",
    "....................................................................................",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppooppppppppppppppppppppooppppppppppppppppppppppppooppppppppppppppppppppppppppe",
    "egggggggggggbbbbbbbbbbbgggggggggggggggggbbbbbbbbbbbbbgggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggogggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppoooooooooppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppppppppge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppgggggge",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppgggggge",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppgggggge",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppgggggge",
    "egggggggggggggggggggggggppppppppppppppppppppgggggggggggggggggggggggppppppppppgggggge",
    "egggggggggggggggggggggggppppppppppppppppppppgggggggggggggggggggggggppppppppppgggggge",
    "eggogggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggppppppppppgggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggge",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "eggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggopppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "eggggoggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggogggggggggggggggggggggggggggggggogggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggogggggggggggggggggggggggggggggpppppppppppppppppppe",
    "egggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggpppppppppppppppppppe",
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
  ],
  "zones": [
  ],
  "rangeMm": [30,45],
  "startLengthMm": [55,80],
  "props": [
    {"id":"playground-1","kind":"playground","x":73.5,"y":19.5,"w":9,"h":6,"solid":true},
    {"id":"shade-sail-1","kind":"shade-sail","x":70.5,"y":17,"w":7,"h":7,"rot":0.2,"solid":false},
    {"id":"shade-sail-2","kind":"shade-sail","x":77,"y":23,"w":7,"h":7,"rot":-0.3,"solid":false},
    {"id":"sandpit-1","kind":"sandpit","x":72,"y":33.5,"w":10,"h":7,"solid":false},
    {"id":"shade-sail-3","kind":"shade-sail","x":72,"y":33.5,"w":8,"h":6,"solid":false},
    {"id":"goal-post-1","kind":"goal-post","x":9.5,"y":26.5,"r":0.15,"solid":true,"sprite":"behind-post"},
    {"id":"goal-post-2","kind":"goal-post","x":9.5,"y":32.5,"r":0.15,"solid":true,"sprite":"goal-post"},
    {"id":"goal-post-3","kind":"goal-post","x":9.5,"y":38.5,"r":0.15,"solid":true,"sprite":"goal-post"},
    {"id":"goal-post-4","kind":"goal-post","x":9.5,"y":44.5,"r":0.15,"solid":true,"sprite":"behind-post"},
    {"id":"goal-post-5","kind":"goal-post","x":59.5,"y":26.5,"r":0.15,"solid":true,"sprite":"behind-post"},
    {"id":"goal-post-6","kind":"goal-post","x":59.5,"y":32.5,"r":0.15,"solid":true,"sprite":"goal-post"},
    {"id":"goal-post-7","kind":"goal-post","x":59.5,"y":38.5,"r":0.15,"solid":true,"sprite":"goal-post"},
    {"id":"goal-post-8","kind":"goal-post","x":59.5,"y":44.5,"r":0.15,"solid":true,"sprite":"behind-post"},
    {"id":"bench-1","kind":"bench","x":8,"y":9.5,"w":2,"h":0.6,"solid":true},
    {"id":"bench-2","kind":"bench","x":30,"y":9.5,"w":2,"h":0.6,"solid":true},
    {"id":"bench-3","kind":"bench","x":56,"y":9.5,"w":2,"h":0.6,"solid":true},
    {"id":"bench-4","kind":"bench","x":63,"y":50,"w":0.6,"h":2,"solid":true},
    {"id":"tap-1","kind":"tap","x":60.5,"y":7.5,"r":0.1,"solid":false,"sprite":"bubbler"},
    {"id":"gum-tree-1","kind":"gum-tree","x":4.5,"y":20.5,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-2","kind":"gum-tree","x":3.5,"y":36.5,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-3","kind":"gum-tree","x":5.5,"y":52.5,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-4","kind":"gum-tree","x":18.5,"y":56.5,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-5","kind":"gum-tree","x":34.5,"y":57.5,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-6","kind":"gum-tree","x":50.5,"y":56.5,"r":0.5,"solid":true,"canopyR":4}
  ],
  "spawn": {"x":2.5,"y":8,"heading":0},
  "utePark": {"x":2.5,"y":7,"heading":0},
  "weedFraction": 0.1,
  "leaves": {"count":[400,600],"areas":[{"x":1,"y":14,"w":8,"h":44},{"x":10,"y":50,"w":46,"h":9}]},
  "camera": {"fit":"follow","allowLandscape":true},
  "mutations": ["lost-ball","magpie-season","sprinkler","bindii","ibis","heavy-leaves","hot-day"]
}
